import { UserPermission } from '@cobliteam/common-types';

const MonitoringPermissions = {
  BLOCK_VEHICLE: UserPermission.BLOCK_VEHICLE,
  VIEW_FLEET_SAFETY: UserPermission.VIEW_FLEET_SAFETY,
  VIEW_ANALYTICS_AND_REPORTS: UserPermission.VIEW_ANALYTICS_AND_REPORTS,
  VIEW_CAMERA_MEDIA: UserPermission.VIEW_CAMERA_MEDIA,
  VIEW_PLACES_OF_INTEREST: UserPermission.VIEW_PLACES_OF_INTEREST,
  CREATE_UPDATE_DELETE_PLACES_OF_INTEREST:
    UserPermission.CREATE_UPDATE_DELETE_PLACES_OF_INTEREST,
  CREATE_UPDATE_DELETE_VEHICLE: UserPermission.CREATE_UPDATE_DELETE_VEHICLE,
};

export default MonitoringPermissions;
